import { FC } from 'react';

import LeafletMap from '@/components/layout/LeafletMap.tsx';

type HoleInOneClaimDetailsLocationProps = {
  latitude: number;
  longitude: number;
  holeNumber: number;
};

const HoleInOneClaimDetailsLocation: FC<HoleInOneClaimDetailsLocationProps> = ({
  latitude,
  longitude,
  holeNumber,
}) => {
  return (
    <div>
      <div className="flex justify-end">
        <i
          className="pi pi-lock text-sm text-gray-400 me-1 leading-none"
          style={{ lineHeight: '1.4' }}
        />
        <p className="text-sm text-gray-400 italic">Auto-captured</p>
      </div>
      <LeafletMap
        latitude={latitude}
        longitude={longitude}
        height={250}
        pointClickText={`Location of claim (Hole Number: ${holeNumber})`}
      />
    </div>
  );
};

export default HoleInOneClaimDetailsLocation;
